module.exports = __webpack_public_path__ + "img/4.be05cb09.jpg";